import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CommonSelectTask from '../../../components/tools/CommonSelectTask/CommonSelectTask';
import { setSelectedTask } from '../../../actions/tools/OrdersSearchActions';

const mapStateToProps = (state) => {
  return {
    taskInputs: [
      {
        id: 'orderDetails',
        title: 'Order Summary',
      },
    ],
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setSelectedTask,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonSelectTask);
